import { createContext, useCallback, useContext, useMemo, useState } from "react";

type AdminLoadingContextType = {
  showLoading: () => void;
  hideLoading: () => void;
  isLoading: boolean;
};

const AdminLoadingContext = createContext<AdminLoadingContextType | null>(null);

export function AdminLoadingProvider({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = useCallback(() => setIsLoading(true), []);
  const hideLoading = useCallback(() => setIsLoading(false), []);

  const value = useMemo(
    () => ({ isLoading, showLoading, hideLoading }),
    [isLoading, showLoading, hideLoading]
  );

  return (
    <AdminLoadingContext.Provider value={value}>
      {children}
    </AdminLoadingContext.Provider>
  );
}

export function useAdminLoading() {
  const context = useContext(AdminLoadingContext);
  if (!context) {
    throw new Error(
      "useAdminLoading must be used inside AdminLoadingProvider"
    );
  }
  return context;
}
